import { required } from 'vuelidate/lib/validators'
import validatorsByFields from '@/utils/validations/validatorsByFields'
import { slugAsyncValidator, slugValidator, validationErrorMessages } from '@/utils/validations/validations'
import citiesSlugsQuery from '@/services/gql/types/City/queries/citiesSlugs.gql'

// import { required } from 'vuelidate/lib/validators'
const { title, subtitle, area, population } = validatorsByFields
// const requiredMsg = 'Обязательное поле'
export default ({ id, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, id, citiesSlugsQuery, ctx, 'cities')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    title,
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })(),
    timezone: { required: { validator: required, message: validationErrorMessages.required } },
    subtitle,
    area,
    population
    // ,timezone: { required: { validator: required, message: requiredMsg } }
  }
}
